var _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgAws(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 28,
    height: 28,
    viewBox: "0 0 28 28",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0 8C0 3.58172 3.58172 0 8 0H20C24.4183 0 28 3.58172 28 8V20C28 24.4183 24.4183 28 20 28H8C3.58172 28 0 24.4183 0 20V8Z",
    fill: "#057DCD"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M17.6667 18.6667H12C11.1346 18.6664 10.2863 18.4256 9.54986 17.971C8.81345 17.5164 8.21795 16.866 7.82992 16.0924C7.44189 15.3188 7.2766 14.4526 7.35253 13.5905C7.42847 12.7285 7.74262 11.9045 8.2599 11.2106C8.77718 10.5168 9.4772 9.98052 10.2817 9.66165C11.0863 9.34278 11.9636 9.25391 12.8158 9.40497C13.6679 9.55603 14.4613 9.94107 15.1072 10.5171C15.7531 11.0931 16.2261 11.8373 16.4733 12.6667H17.6667C18.4623 12.6667 19.2254 12.9827 19.788 13.5453C20.3506 14.108 20.6667 14.871 20.6667 15.6667C20.6667 16.4623 20.3506 17.2254 19.788 17.788C19.2254 18.3506 18.4623 18.6667 17.6667 18.6667Z",
    stroke: "white",
    strokeWidth: 1.33333,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAws);
export default __webpack_public_path__ + "static/media/aws.2a41bf44fb450acfb7da2d809d5da17b.svg";
export { ForwardRef as ReactComponent };